import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_8.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Śliwki i zaproszenie"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p15,
            }}
            content={
                <div>
                    <p>
                        Zabieracie się do pracy ze zdwojonymi siłami. W końcu obaj skorzystacie na tej współpracy. Kiedy wszystkie śliwki leżą już w koszach, żegnasz się z Emilem i wyruszasz do kantoratu.
                    </p>
                    <ul>
                        <li>
                            Do zobaczenia wieczorem u Łukaszewskiego! – woła szczęśliwy Emil, ładując na wóz wiklinowe kosze pełne śliwek.
                        </li>
                    </ul>
                </div>
            }
        />

    );
}